// extracted by mini-css-extract-plugin
export default {"lectureInfoContainer":"CoursesContentTab_lectureInfoContainer__vxPut","btnSeeMore":"CoursesContentTab_btnSeeMore__mQoga"};